export const communitySelector = state => state.communityPage.get('community');
export const communityIsLoadingSelector = state => state.communityPage.get('isLoading');
export const heroIsCommunityAdminSelector = state => state.communityPage.get('heroIsCommunityAdmin');
export const heroIsCommunityMemberSelector = state => state.communityPage.get('heroIsCommunityMember');
